module.exports = __webpack_public_path__ + "img/dark_box2_tag2.06797f8b.png";